<app-header class="z-50"></app-header>
<div class="flex h-[calc(100vh-200px)] w-full items-center justify-center">
    <ng-content></ng-content>
</div>

<app-footer-1></app-footer-1>
